export type SpinnerProps = {
    spinnerClass?: ClassNameSpinner;
    text?: string;
    isMist?: boolean;
}

export enum ClassNameSpinner {
    Big = "spinner-big",
    Small = "spinner-small",
    BigGrid = "spinner-grid-big"
}